import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface ItemsKeyType {
  activity: LocalesKey;
  add: LocalesKey;
  addToSC: LocalesKey;
  addItemToSC: LocalesKey;
  allProformaInvoices: LocalesKey;
  allProformaItemCategories: LocalesKey;
  allProformaProjects: LocalesKey;
  allProformaTasks: LocalesKey;
  areYouSureYouWantToDeleteThisItemYouWillNotBeAbleToUndoThisAction: LocalesKey;
  bind: LocalesKey;
  bindingStatus: LocalesKey;
  bindingStatuses: {
    postponed: LocalesKey;
    mixed: LocalesKey;
    binded: LocalesKey;
  };
  bound: LocalesKey;
  createDate: LocalesKey;
  createItemTag: LocalesKey;
  createNewTag: LocalesKey;
  defaultSplitParts: LocalesKey;
  deleteItemTag: LocalesKey;
  description: LocalesKey;
  eachItemWillHaveASetNumberOfRegularInvoicesPricedProportionally: LocalesKey;
  groupName: LocalesKey;
  groupSimilarItems: LocalesKey;
  groupsLowerCase: LocalesKey;
  hideCompleted: LocalesKey;
  id: LocalesKey;
  inDraft: LocalesKey;
  invoice: LocalesKey;
  itemTag: LocalesKey;
  itemTags: LocalesKey;
  mixed: LocalesKey;
  move: LocalesKey;
  moveTo: LocalesKey;
  name: LocalesKey;
  noScopeOfWorkYet: LocalesKey;
  noSplit: LocalesKey;
  path: LocalesKey;
  payFromDeposit: LocalesKey;
  plural: LocalesKey;
  pluralLowerCase: LocalesKey;
  postpone: LocalesKey;
  postponed: LocalesKey;
  postponedItems: LocalesKey;
  postponedItemsTotal: LocalesKey;
  price: LocalesKey;
  projectCreated: LocalesKey;
  projectCreatedDate: LocalesKey;
  qty: LocalesKey;
  rendering: LocalesKey;
  scopeOfWork: LocalesKey;
  searchByItemName: LocalesKey;
  select: LocalesKey;
  selectedTotal: LocalesKey;
  sentDate: LocalesKey;
  shownTotal: LocalesKey;
  singular: LocalesKey;
  singularLowerCase: LocalesKey;
  splitParts: LocalesKey;
  status: LocalesKey;
  statusInSc: LocalesKey;
  statusChangeDate: LocalesKey;
  subTotal: LocalesKey;
  tag: LocalesKey;
  taskCreated: LocalesKey;
  taskCreatedDate: LocalesKey;
  threeDRenderingServicesPrepayment: LocalesKey;
  total: LocalesKey;
  typeNotesHere: LocalesKey;
  unbind: LocalesKey;
  unbound: LocalesKey;
  ungrouped: LocalesKey;
  updateItemTag: LocalesKey;
  void: LocalesKey;
  youShouldAddAtLeastOneItem: LocalesKey;
}

export const itemsKeys = keyPathMirror<ItemsKeyType, string>(
  {
    add: null,
    addToSC: null,
    addItemToSC: null,
    activity: null,
    areYouSureYouWantToDeleteThisItemYouWillNotBeAbleToUndoThisAction: null,
    allProformaInvoices: null,
    allProformaItemCategories: null,
    allProformaProjects: null,
    allProformaTasks: null,
    bind: null,
    bindingStatus: null,
    bindingStatuses: {
      postponed: null,
      mixed: null,
      binded: null
    },
    bound: null,
    createDate: null,
    createItemTag: null,
    createNewTag: null,
    defaultSplitParts: null,
    deleteItemTag: null,
    description: null,
    eachItemWillHaveASetNumberOfRegularInvoicesPricedProportionally: null,
    groupName: null,
    groupSimilarItems: null,
    groupsLowerCase: null,
    hideCompleted: null,
    id: null,
    inDraft: null,
    invoice: null,
    itemTag: null,
    itemTags: null,
    mixed: null,
    move: null,
    moveTo: null,
    name: null,
    noScopeOfWorkYet: null,
    noSplit: null,
    path: null,
    payFromDeposit: null,
    plural: null,
    pluralLowerCase: null,
    postpone: null,
    postponed: null,
    postponedItems: null,
    postponedItemsTotal: null,
    price: null,
    projectCreated: null,
    projectCreatedDate: null,
    qty: null,
    rendering: null,
    scopeOfWork: null,
    searchByItemName: null,
    select: null,
    selectedTotal: null,
    sentDate: null,
    shownTotal: null,
    singular: null,
    singularLowerCase: null,
    splitParts: null,
    status: null,
    statusInSc: null,
    statusChangeDate: null,
    subTotal: null,
    tag: null,
    taskCreated: null,
    taskCreatedDate: null,
    threeDRenderingServicesPrepayment: null,
    total: null,
    typeNotesHere: null,
    unbind: null,
    unbound: null,
    ungrouped: null,
    updateItemTag: null,
    void: null,
    youShouldAddAtLeastOneItem: null
  },
  'models.items.'
);
